import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {LocalStorageService} from '../local-storage.service';
import {CookieConsentModel} from '../../enum/cookie-consent.enum';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ConsentLocalStorageService extends LocalStorageService<CookieConsentModel> {

  override readonly STORAGE_KEY = 'cookieConsent';
  public readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  override set(value: CookieConsentModel): void {
    try {
      if (!this.isBrowser) return;
      localStorage.setItem(this.STORAGE_KEY, value);
    } catch (error) {
      console.error(
        `[${this.constructor.name}] Failed to save consent "${value}" to localStorage.`,
        error
      );
    }
  }

  override get(): CookieConsentModel | null {
    try {
      if (!this.isBrowser) return null;
      const item = localStorage.getItem(this.STORAGE_KEY);
      return item as CookieConsentModel | null;
    } catch (error) {
      console.error(
        `[${this.constructor.name}] Failed to fetch consent with "${this.STORAGE_KEY}" key from localStorage.`,
        error
      );
      return null;
    }
  }

  override remove(): void {
    try {
      if (!this.isBrowser) return;
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error(
        `[${this.constructor.name}] Failed to delete consent data with "${this.STORAGE_KEY}" key from localStorage.`,
        error
      );
    }
  }

  override clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error(
        `[${this.constructor.name}] Failed to clear localStorage data`,
        error
      );
    }
  }
}
